import { render } from "./Claims.vue?vue&type=template&id=20d315b2&scoped=true"
import script from "./Claims.vue?vue&type=script&lang=js"
export * from "./Claims.vue?vue&type=script&lang=js"

import "./Claims.vue?vue&type=style&index=0&id=20d315b2&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-20d315b2"

export default script